import { ApaduaAPI } from './ApaduaAPI';

export class ApaduaAnnouncementsAPI extends ApaduaAPI {
    resource: string = 'api/apaduaannouncements/';

    getApaduaAnnouncements(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
